// @ts-nocheck
import { ScratchAndDentsProductParameter, updateSndProduct } from "@store/Framework/Services/ScratchAndDentService";
import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = ApiHandler<
    { sndProduct: ScratchAndDentsProductParameter } & HasOnSuccess<string> & HasOnError<string>,
    string
>;

export const DispatchBeginEditProduct: HandlerType = props => {
    props.dispatch({
        type: "Store/Components/ScratchAndDentForm/BeginEditProduct",
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        const result = (await updateSndProduct(props.apiParameter.sndProduct)) as unknown as string;
        props.apiResult = result;
    } catch (error) {
        if ("errorMessage" in error) {
            props.parameter.onError?.(error.errorMessage as string);
            props.dispatch({
                type: "Store/Components/ScratchAndDentForm/CompleteEditProduct",
            });
        }
        return false;
    }
};

export const DispatchCompleteEditProduct: HandlerType = props => {
    props.dispatch({
        type: "Store/Components/ScratchAndDentForm/CompleteEditProduct",
    });
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [
    DispatchBeginEditProduct,
    PopulateApiParameter,
    RequestDataFromApi,
    DispatchCompleteEditProduct,
    ExecuteOnSuccessCallback,
];

const editProduct = createHandlerChainRunner(chain, "EditProduct");
export default editProduct;
